import { render, staticRenderFns } from "./BillingPatientFilters.vue?vue&type=template&id=35a7af18&"
import script from "./BillingPatientFilters.vue?vue&type=script&lang=js&"
export * from "./BillingPatientFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports